// extracted by mini-css-extract-plugin
export var direction = "direction__UnR2";
export var tabContainer = "tab-container__bGcI";
export var tabs = "tabs__AQBB";